/**
 * BottomTabBar.js
 * Fixed bottom navigation bar shown when the app runs inside the native WebView.
 */
import React from 'react';
import { BottomNavigation, BottomNavigationAction, Badge, Paper } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import EventIcon from '@mui/icons-material/Event';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import MessageIcon from '@mui/icons-material/Message';
import PersonIcon from '@mui/icons-material/Person';
import { useLocation, useNavigate } from 'react-router-dom';
import colors from '../common/Colors';

// Map every route to the tab that should appear active
const PATH_TO_TAB = {
  '/home':           0,
  '/attendance':     1,
  '/assignments':    1,
  '/bills':          1,
  '/receipts':       1,
  '/circulars':      2,
  '/notices':        2,
  '/notifications':  2,
  '/online-classes': 2,
  '/online-exams':   2,
  '/gallery':        2,
  '/videos':         2,
  '/birthday':       2,
  '/teachers':       2,
  '/online-payment': 2,
  '/messages':       3,
  '/message-details':3,
  '/profile':        4,
  '/change-password':4,
};

const BottomTabBar = ({ unreadNotificationCount = 0 }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const activeTab = PATH_TO_TAB[location.pathname] ?? 0;

  return (
    <Paper
      elevation={8}
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1200,
        borderTop: '1px solid rgba(0,0,0,0.1)',
      }}
    >
      <BottomNavigation
        value={activeTab}
        onChange={(_, newValue) => {
          const targets = ['/home', '/attendance', '/notices', '/messages', '/profile'];
          navigate(targets[newValue]);
        }}
        sx={{
          height: 58,
          '& .MuiBottomNavigationAction-root': {
            minWidth: 0,
            padding: '6px 0',
            color: 'rgba(0,0,0,0.45)',
          },
          '& .Mui-selected': {
            color: colors.BLUE,
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: '10px',
            '&.Mui-selected': { fontSize: '10px' },
          },
        }}
      >
        <BottomNavigationAction label="Home"       icon={<HomeIcon />} />
        <BottomNavigationAction label="Attendance" icon={<EventIcon />} />
        <BottomNavigationAction
          label="Notices"
          icon={
            unreadNotificationCount > 0 ? (
              <Badge badgeContent={unreadNotificationCount} color="error" max={9}>
                <AnnouncementIcon />
              </Badge>
            ) : (
              <AnnouncementIcon />
            )
          }
        />
        <BottomNavigationAction label="Messages"  icon={<MessageIcon />} />
        <BottomNavigationAction label="Profile"   icon={<PersonIcon />} />
      </BottomNavigation>
    </Paper>
  );
};

export default BottomTabBar;
